import { useCallback } from 'react';
import { useOpenDeeplink } from '../../../../hooks';
import { isNotNil } from '../../../isNotNil';
import {
  appendParams,
  finalizeUrl,
  getDefaultWebviewLink,
} from '../../utils';

export const useMoveToPhotoReviewList = () => {
  const { openDeeplink } = useOpenDeeplink();

  return useCallback(
    (params: {
      goodsSno: number;
      reviewSno?: number;
      titleBar?: boolean;
    }) => {
      const pagePath = `/goods/${params.goodsSno}/reviews/photo/list${isNotNil(params.reviewSno) ? `?review_sno=${params.reviewSno}` : ''}`;

      const link = getDefaultWebviewLink(params.titleBar ?? false);
      appendParams(link, 'url', pagePath);
      openDeeplink(finalizeUrl(link));
    },
    [openDeeplink],
  );
};
